import React, { useState } from "react";
import Navbar from "../components/sub-comp/Navbar.jsx";
import Footer from "../components/sub-comp/MainFooter.jsx";
import FloatingSocialPanels from "../components/sub-comp/FloatingSocialPanels";
import { 
  FaSearch, 
  FaFilter, 
  FaUsers, 
  FaPhone, 
  FaEnvelope, 
  FaArrowRight,
  FaGraduationCap,
  FaLaptop,
  FaShieldAlt,
  FaCode,
  FaChartLine,
  FaDatabase,
  FaNetworkWired,
  FaMobileAlt,
  FaCloud,
  FaRobot,
  FaMicroscope,
  FaCog,
  FaBook,
  FaLightbulb,
  FaTrophy,
  FaCalendarAlt,
  FaMapMarkerAlt,
  FaBuilding,
  FaUserTie,
  FaGlobe,
  FaDesktop,
  FaTabletAlt,
  FaWifi,
  FaVolumeUp,
  FaEye,
  FaHandsHelping,
  FaClipboardList,
  FaChalkboardTeacher,
  FaCertificate,
  FaStar,
  FaHeart,
  FaShare,
  FaBookmark,
  FaTimes
} from "react-icons/fa";

const Departments = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [showFilters, setShowFilters] = useState(false);

  const departments = [
    {
      id: 1,
      name: "Computer Science",
      description: "Advanced computer science education focusing on algorithms, software engineering, and theoretical foundations.",
      category: "Technology",
      head: "Dr. Sarah Johnson",
      email: "cs@jriit.ac.tz",
      phone: "+255 22 123 4001",
      location: "Building A, Floor 3",
      programs: ["Bachelor of Computer Science", "Master of Computer Science", "PhD in Computer Science"],
      faculty: 12,
      students: 180,
      established: "2010",
      icon: FaCode,
      highlights: ["AI/ML Research", "Software Engineering", "Data Structures", "Algorithm Design"],
      research: ["Artificial Intelligence", "Machine Learning", "Computer Vision", "Natural Language Processing"]
    },
    {
      id: 2,
      name: "Information Technology",
      description: "Comprehensive IT program covering systems administration, networking, and enterprise solutions.",
      category: "Technology",
      head: "Prof. Michael Chen",
      email: "it@jriit.ac.tz",
      phone: "+255 22 123 4002",
      location: "Building A, Floor 2",
      programs: ["Bachelor of IT", "Diploma in IT", "Certificate in IT"],
      faculty: 15,
      students: 220,
      established: "2008",
      icon: FaLaptop,
      highlights: ["System Administration", "Network Management", "Database Systems", "Web Development"],
      research: ["Cloud Computing", "IoT Systems", "Enterprise Architecture", "IT Security"]
    },
    {
      id: 3,
      name: "Cybersecurity",
      description: "Specialized cybersecurity program focusing on threat analysis, ethical hacking, and digital forensics.",
      category: "Technology",
      head: "Dr. Emily Rodriguez",
      email: "cyber@jriit.ac.tz",
      phone: "+255 22 123 4003",
      location: "Building B, Floor 2",
      programs: ["Bachelor of Cybersecurity", "Master of Cybersecurity", "Certificate in Ethical Hacking"],
      faculty: 8,
      students: 95,
      established: "2015",
      icon: FaShieldAlt,
      highlights: ["Ethical Hacking", "Digital Forensics", "Network Security", "Risk Assessment"],
      research: ["Threat Intelligence", "Cryptography", "Security Protocols", "Incident Response"]
    },
    {
      id: 4,
      name: "Data Science",
      description: "Interdisciplinary program combining statistics, programming, and domain expertise for data analysis.",
      category: "Technology",
      head: "Dr. David Kim",
      email: "datascience@jriit.ac.tz",
      phone: "+255 22 123 4004",
      location: "Building B, Floor 3",
      programs: ["Bachelor of Data Science", "Master of Data Science", "Certificate in Data Analytics"],
      faculty: 10,
      students: 120,
      established: "2018",
      icon: FaChartLine,
      highlights: ["Statistical Analysis", "Machine Learning", "Big Data", "Data Visualization"],
      research: ["Predictive Analytics", "Deep Learning", "Business Intelligence", "Data Mining"]
    },
    {
      id: 5,
      name: "Computer Engineering",
      description: "Hardware and software integration focusing on embedded systems, computer architecture, and digital design.",
      category: "Engineering",
      head: "Prof. James Wilson",
      email: "ce@jriit.ac.tz",
      phone: "+255 22 123 4005",
      location: "Building C, Floor 2",
      programs: ["Bachelor of Computer Engineering", "Master of Computer Engineering"],
      faculty: 9,
      students: 110,
      established: "2012",
      icon: FaCog,
      highlights: ["Embedded Systems", "Computer Architecture", "Digital Design", "Microprocessors"],
      research: ["IoT Devices", "Hardware Security", "FPGA Design", "Robotics"]
    },
    {
      id: 6,
      name: "Business Administration",
      description: "Comprehensive business education with focus on management, entrepreneurship, and digital business.",
      category: "Business",
      head: "Dr. Maria Garcia",
      email: "business@jriit.ac.tz",
      phone: "+255 22 123 4006",
      location: "Building D, Floor 2",
      programs: ["Bachelor of Business Administration", "MBA", "Certificate in Management"],
      faculty: 14,
      students: 200,
      established: "2005",
      icon: FaBuilding,
      highlights: ["Strategic Management", "Digital Marketing", "Entrepreneurship", "Project Management"],
      research: ["Digital Transformation", "E-commerce", "Supply Chain", "Business Analytics"]
    },
    {
      id: 7,
      name: "Accountancy",
      description: "Professional accounting education with focus on financial reporting, auditing, and taxation.",
      category: "Business",
      head: "Prof. Robert Brown",
      email: "accounting@jriit.ac.tz",
      phone: "+255 22 123 4007",
      location: "Building D, Floor 1",
      programs: ["Bachelor of Accountancy", "Diploma in Accounting", "CPA Preparation"],
      faculty: 11,
      students: 160,
      established: "2006",
      icon: FaBook,
      highlights: ["Financial Accounting", "Auditing", "Taxation", "Management Accounting"],
      research: ["Financial Reporting", "Audit Technology", "Tax Policy", "Corporate Finance"]
    },
    {
      id: 8,
      name: "Travel & Tourism Management",
      description: "Specialized program in tourism management, hospitality, and sustainable tourism development.",
      category: "Hospitality",
      head: "Dr. Lisa Anderson",
      email: "tourism@jriit.ac.tz",
      phone: "+255 22 123 4008",
      location: "Building E, Floor 1",
      programs: ["Bachelor of Tourism Management", "Diploma in Hospitality", "Certificate in Tourism"],
      faculty: 7,
      students: 85,
      established: "2013",
      icon: FaGlobe,
      highlights: ["Tourism Planning", "Hospitality Management", "Sustainable Tourism", "Event Management"],
      research: ["Eco-tourism", "Cultural Tourism", "Digital Tourism", "Tourism Economics"]
    }
  ];

  const categories = [
    { id: "all", name: "All Departments", count: departments.length },
    { id: "Technology", name: "Technology", count: departments.filter(d => d.category === "Technology").length },
    { id: "Engineering", name: "Engineering", count: departments.filter(d => d.category === "Engineering").length },
    { id: "Business", name: "Business", count: departments.filter(d => d.category === "Business").length },
    { id: "Hospitality", name: "Hospitality", count: departments.filter(d => d.category === "Hospitality").length }
  ];

  const filteredDepartments = departments.filter(dept => {
    const matchesSearch = dept.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         dept.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         dept.head.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = selectedCategory === "all" || dept.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  const totalFaculty = departments.reduce((sum, dept) => sum + dept.faculty, 0);
  const totalStudents = departments.reduce((sum, dept) => sum + dept.students, 0);

  return (
    <div>
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-custom-pink via-purple-900 to-indigo-900 text-white py-20 lg:py-32">
        <div className="absolute inset-0 bg-black/30"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6">
            Academic Departments
          </h1>
          <p className="text-xl sm:text-2xl mb-8 max-w-3xl mx-auto">
            Explore our diverse range of academic departments, each dedicated to excellence in education and research.
          </p>
          <div className="flex flex-wrap justify-center gap-8 text-center">
            <div className="flex items-center gap-2">
              <FaBuilding className="text-gold text-2xl" />
              <span className="text-lg font-semibold">{departments.length} Departments</span>
            </div>
            <div className="flex items-center gap-2">
              <FaUsers className="text-gold text-2xl" />
              <span className="text-lg font-semibold">{totalFaculty} Faculty</span>
            </div>
            <div className="flex items-center gap-2">
              <FaGraduationCap className="text-gold text-2xl" />
              <span className="text-lg font-semibold">{totalStudents} Students</span>
            </div>
          </div>
        </div>
      </section>

      {/* Search and Filter Section */}
      <section className="py-12 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row gap-6 items-center justify-between">
            {/* Search Bar */}
            <div className="flex-1 max-w-md">
              <div className="relative">
                <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <input
                  type="text"
                  placeholder="Search departments, faculty, or programs..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-custom-pink focus:border-transparent"
                />
              </div>
            </div>

            {/* Filter Button */}
            <button
              onClick={() => setShowFilters(!showFilters)}
              className="flex items-center gap-2 px-6 py-3 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
            >
              <FaFilter className="text-gray-600" />
              <span>Filter by Category</span>
            </button>
          </div>

          {/* Filter Categories */}
          {showFilters && (
            <div className="mt-6 p-6 bg-white rounded-xl shadow-lg">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {categories.map((category) => (
                  <button
                    key={category.id}
                    onClick={() => setSelectedCategory(category.id)}
                    className={`p-4 rounded-lg text-left transition-colors ${
                      selectedCategory === category.id
                        ? "bg-custom-pink text-white"
                        : "bg-gray-50 hover:bg-gray-100"
                    }`}
                  >
                    <div className="font-semibold">{category.name}</div>
                    <div className="text-sm opacity-75">{category.count} departments</div>
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Departments Grid */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold text-custom-pink mb-4">
              {selectedCategory === "all" ? "All Departments" : `${selectedCategory} Departments`}
            </h2>
            <p className="text-lg text-gray-600">
              {filteredDepartments.length} department{filteredDepartments.length !== 1 ? 's' : ''} found
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredDepartments.map((dept) => {
              const IconComponent = dept.icon;
              return (
                <div key={dept.id} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 border border-gray-100">
                  {/* Department Header */}
                  <div className="p-6 border-b border-gray-100">
                    <div className="flex items-start gap-4 mb-4">
                      <div className="bg-custom-pink text-white p-3 rounded-xl">
                        <IconComponent className="text-2xl" />
                      </div>
                      <div className="flex-1">
                        <h3 className="text-xl font-bold text-gray-900 mb-1">{dept.name}</h3>
                        <p className="text-sm text-gold font-semibold">{dept.category}</p>
                      </div>
                    </div>
                    <p className="text-gray-600 text-sm leading-relaxed">{dept.description}</p>
                  </div>

                  {/* Department Stats */}
                  <div className="p-6">
                    <div className="grid grid-cols-3 gap-4 mb-6">
                      <div className="text-center">
                        <div className="text-2xl font-bold text-custom-pink">{dept.faculty}</div>
                        <div className="text-xs text-gray-500">Faculty</div>
                      </div>
                      <div className="text-center">
                        <div className="text-2xl font-bold text-custom-pink">{dept.students}</div>
                        <div className="text-xs text-gray-500">Students</div>
                      </div>
                      <div className="text-center">
                        <div className="text-2xl font-bold text-custom-pink">{dept.established}</div>
                        <div className="text-xs text-gray-500">Established</div>
                      </div>
                    </div>

                    {/* Department Head */}
                    <div className="mb-4 p-3 bg-gray-50 rounded-lg">
                      <div className="flex items-center gap-2 mb-1">
                        <FaUserTie className="text-gold text-sm" />
                        <span className="text-sm font-semibold text-gray-900">Department Head</span>
                      </div>
                      <div className="text-sm text-gray-700">{dept.head}</div>
                    </div>

                    {/* Programs */}
                    <div className="mb-4">
                      <h4 className="text-sm font-semibold text-gray-900 mb-2">Programs Offered:</h4>
                      <div className="space-y-1">
                        {dept.programs.slice(0, 2).map((program, index) => (
                          <div key={index} className="text-xs text-gray-600">• {program}</div>
                        ))}
                        {dept.programs.length > 2 && (
                          <div className="text-xs text-gold">+{dept.programs.length - 2} more</div>
                        )}
                      </div>
                    </div>

                    {/* Highlights */}
                    <div className="mb-6">
                      <h4 className="text-sm font-semibold text-gray-900 mb-2">Key Areas:</h4>
                      <div className="flex flex-wrap gap-1">
                        {dept.highlights.slice(0, 3).map((highlight, index) => (
                          <span key={index} className="bg-gold text-white px-2 py-1 rounded text-xs">
                            {highlight}
                          </span>
                        ))}
                        {dept.highlights.length > 3 && (
                          <span className="bg-gray-200 text-gray-600 px-2 py-1 rounded text-xs">
                            +{dept.highlights.length - 3}
                          </span>
                        )}
                      </div>
                    </div>

                    {/* Contact Info */}
                    <div className="space-y-2 mb-6">
                      <div className="flex items-center gap-2 text-xs text-gray-600">
                        <FaMapMarkerAlt className="text-gold" />
                        <span>{dept.location}</span>
                      </div>
                      <div className="flex items-center gap-2 text-xs text-gray-600">
                        <FaPhone className="text-gold" />
                        <span>{dept.phone}</span>
                      </div>
                      <div className="flex items-center gap-2 text-xs text-gray-600">
                        <FaEnvelope className="text-gold" />
                        <span>{dept.email}</span>
                      </div>
                    </div>

                    {/* Action Button */}
                    <button className="w-full bg-custom-pink text-white py-2 px-4 rounded-lg hover:bg-gold transition-colors duration-300 font-semibold text-sm flex items-center justify-center gap-2">
                      View Department Details
                      <FaArrowRight className="text-xs" />
                    </button>
                  </div>
                </div>
              );
            })}
          </div>

          {filteredDepartments.length === 0 && (
            <div className="text-center py-12">
              <FaSearch className="text-6xl text-gray-300 mx-auto mb-4" />
              <h3 className="text-xl font-semibold text-gray-600 mb-2">No departments found</h3>
              <p className="text-gray-500">Try adjusting your search terms or filters</p>
            </div>
          )}
        </div>
      </section>

      {/* Department Statistics */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold text-custom-pink mb-4">
              Department Statistics
            </h2>
            <p className="text-lg text-gray-600">
              Our departments at a glance
            </p>
          </div>

          <div className="grid md:grid-cols-4 gap-8">
            <div className="text-center p-6 bg-white rounded-xl shadow-lg">
              <div className="bg-custom-pink text-white p-4 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                <FaBuilding className="text-2xl" />
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-2">{departments.length}</div>
              <div className="text-gray-600">Total Departments</div>
            </div>

            <div className="text-center p-6 bg-white rounded-xl shadow-lg">
              <div className="bg-gold text-white p-4 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                <FaUsers className="text-2xl" />
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-2">{totalFaculty}</div>
              <div className="text-gray-600">Faculty Members</div>
            </div>

            <div className="text-center p-6 bg-white rounded-xl shadow-lg">
              <div className="bg-custom-pink text-white p-4 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                <FaGraduationCap className="text-2xl" />
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-2">{totalStudents}</div>
              <div className="text-gray-600">Students Enrolled</div>
            </div>

            <div className="text-center p-6 bg-white rounded-xl shadow-lg">
              <div className="bg-gold text-white p-4 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                <FaTrophy className="text-2xl" />
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-2">15+</div>
              <div className="text-gray-600">Years of Excellence</div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <FloatingSocialPanels />
    </div>
  );
};

export default Departments;